import React from "react";
import cx from "clsx";
export var ItemTitle = function (_a) {
    var title = _a.title, isAlternative = _a.isAlternative, hasChip = _a.hasChip;
    var baseTitleClass = "group-hover:text-primary-200 transition-text duration-200";
    var conditionalClasses = {
        "text-sm leading-5 md:flex md:items-center": isAlternative,
        "text-base font-semibold tracking-wide": !isAlternative,
        "pb-1": hasChip,
    };
    return React.createElement("p", { className: cx(baseTitleClass, conditionalClasses) }, title);
};
//# sourceMappingURL=ItemTitle.js.map